// extracted by mini-css-extract-plugin
export default {"inputControl":"Date_inputControl__BWnnm","label":"Date_label__IJOKP","requiredMark":"Date_requiredMark__s3N5u","inputField":"Date_inputField__9hA34"};